// extracted by mini-css-extract-plugin
export var messageSideLeft = "_j8-1";
export var messageSideRight = "_j8-2";
export var orderLookupBubbleContainer = "_j8-0";
export var submitButton = "_j8-3";